import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService, UrlParam } from './classes/BaseService';

@Injectable({
  providedIn: 'root'
})
export class BlocklistService extends BaseService {

  apiUrl = "Blocklist.php?";

  constructor(protected http: HttpClient) {
    super(http);
  }

  addItem(country: string, store: string, itemType: string, sessionToken: string, idInStore: string) {
    let url = this.serverUrl + this.apiUrl + this.buildUrlParams(
      new UrlParam("country", country),
      new UrlParam("store", store),
      new UrlParam("action", "addItem"),
      new UrlParam("itemType", itemType),
      new UrlParam("idInStore", idInStore)
    );

    return this.post(url, this.buildUrlParams(new UrlParam("sessionToken", sessionToken)));
  }

  removeItem(country: string, store: string, itemType: string, sessionToken: string, idInStore: string) {
    let url = this.serverUrl + this.apiUrl + this.buildUrlParams(
      new UrlParam("country", country),
      new UrlParam("store", store),
      new UrlParam("action", "removeItem"),
      new UrlParam("itemType", itemType),
      new UrlParam("idInStore", idInStore)
    );

    return this.post(url, this.buildUrlParams(new UrlParam("sessionToken", sessionToken)));
  }

  getShortBlocklist(country: string, store: string, sessionToken: string) {
    let url = this.serverUrl + this.apiUrl + this.buildUrlParams(
      new UrlParam("country", country),
      new UrlParam("store", store),
      new UrlParam("action", "getShortItemList"),
    );

    return this.post(url, this.buildUrlParams(new UrlParam("sessionToken", sessionToken)));
  }

  getDetailItemList(sessionToken: string, store: string, mediaType: string, country: string,
    genreIds: string, quality: string, sort: string, offset: number, limit: number) {

    const url = this.serverUrl + this.apiUrl + this.buildUrlParams(
      new UrlParam('action', 'getDetailItemList'),
      new UrlParam('store', store),
      new UrlParam('mediaType', mediaType),
      new UrlParam('country', country),
      new UrlParam('genreIds', genreIds),
      new UrlParam('quality', quality),
      new UrlParam('sort', sort),
      new UrlParam('offset', offset.toString()),
      new UrlParam('limit', limit.toString()),
      new UrlParam('sessionToken', sessionToken)
    );

    return this.get(url);

  }

}